class Validator {
    private useMethods: any = {}
    private value: any
    private errors: string[] = []

    constructor(value: any = '') {
        this.value = value
    }

    setValue(value: any) {
        this.value = value
        return this
    }

    private setError(errMessage: string) {
        this.errors.push(errMessage)
        return
    }

    private removeError(errMessage: string) {
        this.errors = this.errors.filter((err) => err !== errMessage)
        return
    }
    
    min(params: {length: number, message: string}) {
        this.useMethods.min = params

        if (this.value.length < params.length) {
            this.setError(params.message)
        } else {
            this.removeError(params.message)
        }
        return this;
    }
    
    max(params: {length: number, message: string}) {
        this.useMethods.max = params

        if (this.value.length > params.length) {
            this.setError(params.message)
        } else {
            this.removeError(params.message)
        }
        return this;
    }

    isEquals(params: {otherValue: any, message: string}) {
        this.useMethods.isEquals = params

        if (this.value != params.otherValue) {
            this.setError(params.message)
        } else {
            this.removeError(params.message)
        }
        return this;
    }
    
    
    regex(params: { pattern: RegExp; message: string }) {
        this.useMethods.regex = params

        if (this.value == null || String(this.value).trim() === "") {
        this.removeError(params.message)
        return this
        }

        if (!params.pattern.test(String(this.value))) {
        this.setError(params.message)
        } else {
        this.removeError(params.message)
        }
        return this
    }

    required(params: {message: string}) {
        this.useMethods.required = params

        if (this.value == null || String(this.value).trim().length === 0) {
            this.setError(params.message)
        } else {
            this.removeError(params.message)
        }
        return this;
    }

    isNumber(params: {message: string}) {
        this.useMethods.isNumber = params

        if (isNaN(this.value)) {
            this.setError(params.message)
        } else {
            this.removeError(params.message)
        }
        return this;
    }

    when(params: {
        condition: boolean,
        then: (schema: Validator) => void,
        otherwise?: (schema: Validator) => void,
    }) {
        this.useMethods.when = params

        if (params.condition) {
            params.then(this)
        } else if (params.otherwise) {
            params.otherwise(this)
        };

        return this
    }

    use(arr: Validator[] | Validator) {
        if (Array.isArray(arr)) {
            arr.map(({ useMethods }) => {
                this.useMethods = {
                    ...this.useMethods,
                    ...useMethods
                }
            })
        } else {
            this.useMethods = {
                ...this.useMethods,
                ...arr.useMethods
            }
        }
        
        return this
    }

    email(params: { message: string }) {
        this.useMethods.email = params

        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!pattern.test(this.value)) {
        this.setError(params.message)
        } else {
        this.removeError(params.message)
        }
        return this
    }

    futureDate(params: { message: string }) {
        this.useMethods.futureDate = params

        if (this.value == null || String(this.value).trim() === "") {
        this.removeError(params.message)
        return this
        }

        const raw = String(this.value)
        const selectedDate = new Date(raw)

        if (isNaN(selectedDate.getTime())) {
        this.setError(params.message)
        return this
        }

        const now = new Date()
        
        if (selectedDate.getTime() <= now.getTime()) {
        this.setError(params.message)
        } else {
        this.removeError(params.message)
        }

        return this
    }

    validate() {
        for (const method in this.useMethods) {
            this[method as keyof Validator](this.useMethods[method])
        }

        return {
            isValid: this.errors.length === 0,
            errors: this.errors
        }
    }
}

class ObjectSchema {
    schema: { [key: string]: Validator }

    constructor(schema: { [key: string]: Validator }) {
        this.schema = schema
    }

    validate(values: { [key: string]: any }) {
        const errors: any = {};
    
        for (const field in this.schema) {
            const schemaItem = this.schema[field];
    
            if (schemaItem instanceof ObjectSchema) {
                const nestedErrors = schemaItem.validate(values[field] || {});
                if (Object.keys(nestedErrors).length > 0) {
                    errors[field] = nestedErrors
                }
            } else {
                const validator = schemaItem.setValue(values[field]);
                const validationResult = validator.validate();
    
                if (!validationResult.isValid) {
                    errors[field] = validationResult.errors;
                }
            }
        }
        return errors;
    }    
}

const v = {
    object: (schema: { [key: string]: any }) => new ObjectSchema(schema),
    methods: () => new Validator()
}

export default v